import { useState } from 'react';
import { ArrowUpAZ, ArrowDownZA, ChevronDown, ListFilter, ArrowUp01, ArrowDown01, ArrowDown10 } from 'lucide-react'; // icons

const FILTER_OPTIONS = [
    { label: 'ID', value: 'id' },
    { label: 'Email', value: 'email_address' },
    { label: 'First Name', value: 'first_name' },
    { label: 'Surname', value: 'surname' },
    { label: 'Phone Number', value: 'phone_number' },
    { label: 'Volunteer', value: 'volunteer' },
];

export default function FilterBar({ handleSearch, sortConfig, toggleSort }) {
    const [showDropdown, setShowDropdown] = useState(false);

    const handleSelectFilter = (key) => {
        toggleSort(key); // Will sort by selected key
        setShowDropdown(false);
    };

    const handleDirectionToggle = () => {
        toggleSort(sortConfig.key); // toggles asc/desc for current key
    };

    return (
        <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
            <div className="w-full flex flex-row items-center justify-between gap-4">
                {/* Search Bar */}
                <input
                    type="text"
                    placeholder="Search by any field..."
                    onChange={handleSearch}
                    className="w-full md:max-w-md p-3 bg-gray-800 text-white rounded-2xl border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-300"
                />

                {/* Filter Section */}
                <div className="relative">
                    <button
                        onClick={() => setShowDropdown(!showDropdown)}
                        className="flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition text-xs md:text-[14px]"
                    >
                        <ListFilter className="w-4 h-4" /> {sortConfig.key.replace('_', ' ').toUpperCase()}
                        <ChevronDown className="w-4 h-4" />
                    </button>

                    {showDropdown && (
                        <div className="absolute right-0 mt-2 bg-white text-gray-800 rounded-lg shadow-lg w-48 z-10">
                            {FILTER_OPTIONS.map((option) => (
                                <button
                                    key={option.value}
                                    onClick={() => handleSelectFilter(option.value)}
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Asc/Desc Toggle */}
            <button
                onClick={handleDirectionToggle}
                className="flex items-center justify-center bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition"
                title="Toggle sort direction"
            >
                {sortConfig.direction === 'asc' ? 
                    sortConfig.key === "id" ? <ArrowUp01 className="w-5 h-5" /> : <ArrowUpAZ className="w-5 h-5" />
                 : 
                 sortConfig.key === "id" ? <ArrowDown10 className="w-5 h-5" /> : <ArrowDownZA className="w-5 h-5" />
                
                }
            </button>
        </div>
    );
}